// @flow
import AxiosClient from '../../../admin/models/AxiosClient';
import type { AxiosPromise } from 'axios';

export default class FundraisingSimulationClient extends AxiosClient {
  simulate(params: Object): AxiosPromise<any> {
    return this.buildClient().post(
      '/api/v1/fundraising_simuration/simulate',
      params,
    );
  }

  create(params: Object): AxiosPromise<any> {
    return this.buildClient().post('/api/v1/fundraising_simuration', params);
  }
}
